module.exports = __webpack_public_path__ + "img/0046.b77ccd07.gif";